
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faIdCard, faSearch, } from "@fortawesome/free-solid-svg-icons";
import { Col, FormControl, FormGroup, FormLabel, Row, Button, Modal, } from "react-bootstrap";
import ModalSearchCnpj from "../Modal/ModalSearchCnpj";
import ModalDataCliente from "../Modal/ModalDataCliente";
import { toast } from "react-toastify";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";

interface Data {
  id: any,
  formData: any;
  setFormData: any
  handleChange: any,
  handleBlur: any,
  errors: any
}

const ClienteInfo: React.FC<Data> = ({ id, formData, setFormData, errors, handleBlur, handleChange }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalCliente, setModalCliente] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [customerData, setCustomerData] = useState({
    cnpj: '',
    ierg: '',
    razao: '',
    nome_fantasia: '',
    telefone: '',
    celular: '',
    email: '',
  })

  const getData = (cnpj: string) => {
    setLoading(true);
  
    api.get(BackEndRoutes.routes.CLIENTES.FIND.replace(":cnpj", cnpj))
      .then((response: any) => {
        const data = response.data;
  
        if (data?.cnpj) {
          setCustomerData({
            cnpj: data.cnpj || "",
            ierg: data.ierg || "",
            razao: data.razao || "",
            nome_fantasia: data.nome_fantasia || "",
            telefone: data.telefone || "",
            celular: data.celular || "",
            email: data.email || "",
          });
  
          console.log("Dados do cliente:", customerData);
          setModalCliente(true);

        } else {
          toast.error("Insira um CNPJ válido.");
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar o cliente", error);
        toast.error("Erro ao buscar os dados do cliente.");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  

  return (
    <Row className="mt-4 d-flex justify-content-center">
      <div className="d-flex align-items-center gap-2 justify-content-start">
        <FontAwesomeIcon icon={faIdCard} className="fa-xl mb-2" />
        <h4>Informações do Cliente</h4>
      </div>
      {id ?
        <>
          <Col className="col-lg-4 col-md-4 col-12">
            <FormGroup>
              <FormLabel>CPF/CNPJ do Cliente</FormLabel>
              <FormControl
                type="text"
                id="cnpj_cliente"
                placeholder=""
                value={formData.cnpj_cliente}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.cnpj_cliente}
                disabled={!!id}
              />
              <FormControl.Feedback type="invalid">{errors.cnpj_cliente}</FormControl.Feedback>
            </FormGroup>
          </Col>
          <Col className="col-lg-8 col-md-8 col-12 ">
            <FormLabel> Razão Social - Nome Fantasia </FormLabel>
            <FormGroup className="d-flex column">
              <Button className="btn btn-secondary"
                style={{ borderRadius: '5px 0px 0px 5px' }}
                onClick={() => getData(formData.cnpj_cliente)}>
                <FontAwesomeIcon icon={faIdCard} />
              </Button>
              <FormControl
                type="text"
                id="razao"
                value={formData.razao}
                placeholder={formData.razao}
                onBlur={handleBlur}
                style={{ borderRadius: '0px 5px 5px 0px' }}
                onChange={handleChange}
                isInvalid={!!errors.razao}
                disabled={!!id}
              />
            </FormGroup>
            <FormControl.Feedback type="invalid">{errors.razao}</FormControl.Feedback>
          </Col>
        </>
        :
        <>
          <Col className="col-lg-3 col-md-3 col-12">
            <FormLabel>Critério de pesquisa</FormLabel>
            <select
              id="criterio"
              className="form-control"
              disabled
            >
              <option value="cnpj">CNPJ</option>
            </select>
          </Col>
          <Col className="col-lg-3 col-md-3 col-12">
            <div className="d-flex align-items-center row">
              <FormLabel>Cnpj</FormLabel>
              <FormGroup className="d-flex column">
                <Button className="btn btn-secondary"
                  style={{ borderRadius: '5px 0px 0px 5px' }}
                  onClick={() => getData(formData.cnpj_cliente)}>
                  <FontAwesomeIcon icon={faIdCard} />
                </Button>
                <FormControl
                  type="text"
                  id="cnpj_cliente"
                  placeholder=""
                  value={formData.cnpj_cliente}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={!!errors.cnpj_cliente}
                  style={{ borderRadius: "0px 0px 0px 0px" }}
                  disabled={!!id}
                />
                <Button type="button" onClick={() => setShowModal(true)} style={{ borderRadius: '0px 5px 5px 0px' }}>
                  <FontAwesomeIcon icon={faSearch} />
                </Button>
              </FormGroup>
              <FormControl.Feedback type="invalid">{errors.cnpj_cliente}</FormControl.Feedback>
            </div>
          </Col>
        </>
      }
      <Col className="col-12 mt-2 d-flex justify-content-center">
      </Col>

      <ModalDataCliente
        show={modalCliente}
        customerData={customerData.cnpj}
        onCancel={() => {
          setModalCliente(false);
        }}
      />

      <ModalSearchCnpj
        show={showModal}
        setFormData={setFormData}
        onCancel={() => {
          setShowModal(false);
        }}
      />
    </Row>
  );
};

export default ClienteInfo;
